import Marquee from "react-fast-marquee";

const items = [
    "AIR FILTRATION",
    "GAS PRESSURIZATION",
    "CLIMATE CONTROL",
    "ATEX ZONE 1",
    "OFFSHORE ONLY",
    "24/7 DISPATCH",
];

export default function TextMarquee() {
    return (
        <section
            data-testid="marquee-section"
            className="border-y border-border bg-abyss py-8 overflow-hidden"
        >
            <Marquee speed={45} gradient={false} autoFill>
                {items.map((t, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-heading font-black text-transparent text-6xl md:text-[7vw] leading-none px-8 [-webkit-text-stroke:1px_rgba(255,255,255,0.12)]">
                            {t}
                        </span>
                        <span className="h-3 w-3 bg-safety rotate-45 mx-4" />
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
